import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=0093b7a1&scoped=true"
import script from "./SummaryItem.vue?vue&type=script&lang=js"
export * from "./SummaryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0093b7a1",
  null
  
)

export default component.exports